import { CSSProperties } from 'react';
import * as STYLE from '../UIConstants';

export const PageContainerStyle: CSSProperties = {
    display: STYLE.CONSTANTS.DISPLAY.FLEX,
    flex: '1 1',
    backgroundColor: STYLE.CONSTANTS.COLORS.PAGE_BACKGROUND,
};

export const PageStyle: CSSProperties = {
    overflowY: 'auto',
    display: STYLE.CONSTANTS.DISPLAY.FLEX,
    flexGrow: 1
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/styles/Page.ts